var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('AppBar',{attrs:{"rutas":_vm.rutas}}),_c('v-row',{staticClass:"mx-5"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }